/* The Apex Pass offer, stated once. Every page that mentions the Pass reads
 * these, so the stores can never drift apart again (ruling 2026-09-26).
 * The authoritative price math is the backend's /api/v1/pass/quote. */

export const PASS_PRICE_USD = 99;
export const PASS_DISCOUNT_PCT = 30;

export const PASS_LINE = `Apex Pass members get ${PASS_DISCOUNT_PCT}% off every digital product in every Apex store: $${PASS_PRICE_USD}/yr.`;
export const PASS_SHORT = `${PASS_DISCOUNT_PCT}% off with the Apex Pass`;
export const PASS_HREF = "/apex-pass";

/* What counts as digital (discounted) vs not, in plain words. */
export const PASS_INCLUDED = [
  "Wall art (digital files)",
  "Stickers (digital files)",
  "Canva templates",
  "Notion systems",
  "3D model files",
  "Business-in-a-Box Starter and Professional kits",
  "Ebooks and audiobooks",
];
export const PASS_EXCLUDED = [
  "Printed and shipped products",
  "AI tools and AI add-ons",
  "Forge website builds",
  "Done-for-you and live-service tiers",
];

/** Display-only member price. Checkout re-prices on the server; this only shows it. */
export function displayMemberPrice(listUsd: number): number | null {
  const cents = Math.round(listUsd * 100);
  const m = Math.round(cents * (1 - PASS_DISCOUNT_PCT / 100));
  const net = m * (1 - 0.029 - 0.45) - 30;
  return m >= 50 && net > 0 ? m / 100 : null;
}
